export default __webpack_public_path__ + "static/media/carousel-1.3d9fd042.jpg";